import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { lightBlue, darkBlue, MQ } from '@css/constants'

export const Title = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(24)};
  text-align: center;
  max-width: 350px;
  margin: 0 auto;

  ${MQ.SMALL_SCREENS} {
    ${fontSize(20)};
  }
`)

export const Subtitle = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(16)};
  margin-top: 20px;
`)

export const List = styled('ul')(css`
  display: flex;
  flex-direction: column;
  list-style: none;
  max-width: 360px;
  margin: 0 auto;
`)

export const ListItem = styled('li')(css`
  display: flex;
  margin-top: 32px;
  text-align: left;

  & > svg {
    width: 64px;
    height: 64px;
    margin-right: 16px;
    flex-shrink: 0;
  }

  ${MQ.SMALL_SCREENS} {
    margin-top: 18px;

    & > svg {
      margin-right: 8px;
    }
  }
`)

export const ListItemTitle = styled('div')(css`
  ${FontNormal(500)};
  ${fontSize(16)};
  color: ${lightBlue};
`)

export const ListItemSubTitle = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(20)};
  color: ${darkBlue};
`)

export const ListItemText = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(16)};
  margin-top: 6px;
`)

export const Footer = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(14)};
  font-style: italic;
  margin-top: 10px;
`)

export const takeQuizBtnStyles = css`
  max-width: 291px;
  width: 100%;
  margin-top: 16px;
`

export const MarginTopDiv = styled.div`
  margin-top: 20px;
`;
